export default __webpack_public_path__ + "static/media/num-01.71ab8a83.svg";